export default __webpack_public_path__ + "static/media/twinkle.fc3f1952.png";